/* eslint-disable import/prefer-default-export */
import { PaymentMethod as InvoicePaymentMethod } from '../constants/paymentMethod';
import { PaymentMethod as FormPaymentMethod } from '../components/PaymentForm/PaymentMethodsForm';

export function getFormPaymentMethod(
    invoicePaymentMethod: string,
): FormPaymentMethod[] {
    switch (invoicePaymentMethod) {
        case InvoicePaymentMethod.Barcode:
            return ['boleto'];
        case InvoicePaymentMethod.CreditCard:
            return ['credit_card', 'two_cards'];
        case InvoicePaymentMethod.CreditCardAndCreditCard:
            return ['two_cards'];
        case InvoicePaymentMethod.CreditCardAndBarcode:
            return ['card_boleto'];
        default:
            return [];
    }
}
